module.exports = __webpack_public_path__ + "img/delete.d2f93786.svg";